import { SvgIcon } from '@mui/material';
import { RoutalPalette } from '@nx-smartmonkey/ui';
import React from 'react';

interface RatingStarProps {
  isHover?: boolean;
  style?: React.CSSProperties;
}

export default function ChatIcon({ isHover = false, style = {}, ...props }: RatingStarProps) {
  return (
    <SvgIcon {...props} viewBox="0 0 19 20" style={{ width: `20px`, height: `20px`, fill: `transparent`, ...style }}>
      <g>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M1.06928 1.62476C1.52063 1.17342 2.13278 0.919861 2.77107 0.919861H16.1179C16.7562 0.919861 17.3684 1.17342 17.8197 1.62476C18.2711 2.07611 18.5246 2.68826 18.5246 3.32655V12.86C18.5246 13.4983 18.2711 14.1105 17.8197 14.5618C17.3684 15.0132 16.7562 15.2667 16.1179 15.2667H4.88487L1.21793 18.9337C1.07493 19.0767 0.859875 19.1194 0.673038 19.042C0.4862 18.9646 0.36438 18.7823 0.36438 18.5801V3.32655C0.36438 2.68826 0.617941 2.07611 1.06928 1.62476ZM5.63108 9.04671C6.1576 9.04671 6.58443 8.61988 6.58443 8.09336C6.58443 7.56684 6.1576 7.14001 5.63108 7.14001C5.10456 7.14001 4.67773 7.56684 4.67773 8.09336C4.67773 8.61988 5.10456 9.04671 5.63108 9.04671ZM10.3978 8.09336C10.3978 8.61988 9.97095 9.04671 9.44444 9.04671C8.91792 9.04671 8.49109 8.61988 8.49109 8.09336C8.49109 7.56684 8.91792 7.14001 9.44444 7.14001C9.97095 7.14001 10.3978 7.56684 10.3978 8.09336ZM13.2578 9.04671C13.7843 9.04671 14.2111 8.61988 14.2111 8.09336C14.2111 7.56684 13.7843 7.14001 13.2578 7.14001C12.7313 7.14001 12.3044 7.56684 12.3044 8.09336C12.3044 8.61988 12.7313 9.04671 13.2578 9.04671Z"
          fill={isHover ? RoutalPalette.primary20 : RoutalPalette.secondary40}
        />
      </g>
    </SvgIcon>
  );
}
